let pendingLayout = [];
let pendingTransforms = [];
let updated = {};
let pendingSetDisplay = [];

const addToPendingLayout = (eNode) => {
  pendingLayout.push(eNode);
};

const addToPendingSetDisplay = (eNode) => {
  pendingSetDisplay.push(eNode);
};

const addToPendingTransforms = (eNode) => {
  pendingTransforms.push(eNode);
};

const runPendingUpdates = () => {
  pendingLayout = pendingLayout.sort((eNodeA, eNodeB) => eNodeA.depth - eNodeB.depth);
  for (const eNode of pendingLayout) {
    if (updated[eNode.uid]) continue;

    recursiveUpdate(eNode);
  }

  for (const eNode of pendingTransforms) {
    if (updated[eNode.uid]) continue;

    eNode.envImplementation.applyTransforms(eNode);
  }

  for (const eNode of pendingSetDisplay) {
    if (updated[eNode.uid]) continue;

    eNode.envImplementation.setDisplay(eNode);
  }

  pendingTransforms = [];
  pendingLayout = [];
  pendingSetDisplay = [];
  updated = {};
};

const recursiveUpdate = (eNode) => {
  eNode.envImplementation.applyLayout(eNode);
  eNode.envImplementation.applyTransforms(eNode);

  updated[eNode.uid] = true;
  if (!eNode.children) return;

  for (const childENode of eNode.children) {
    recursiveUpdate(childENode);
  }
};

const addPropertyValue = (propertyString, property, value) => {
  // Match property with balanced parentheses to handle nested functions like rgb(), hsla()
  const pattern = `\\b${property}\\((?:[^()]*|\\([^()]*\\))*\\)`;
  const regex = new RegExp(pattern, 'g');

  if (regex.test(propertyString)) {
    return propertyString.replace(new RegExp(pattern, 'g'), `${property}(${value})`);
  }

  return propertyString.trim() + ` ${property}(${value})`.trim();
}

const removePropertyValue = (propertyString, property) => {
  // Match property with balanced parentheses to handle nested functions like rgb(), hsla()
  const pattern = `\\b${property}\\((?:[^()]*|\\([^()]*\\))*\\)`;
  const regex = new RegExp(pattern, 'g');
  return propertyString.replace(regex, '').trim();
}

const cssValue = (value) => typeof value === "string" ? value : `${value}px`;

export {
  addPropertyValue,
  addToPendingTransforms,
  addToPendingSetDisplay,
  addToPendingLayout,
  cssValue,
  recursiveUpdate,
  removePropertyValue,
  runPendingUpdates,
};
